export default "__VITE_ASSET__CZO1VmZY__"